export default __webpack_public_path__ + "static/media/dev-group-tint.003e5859.jpg";